// Plan Management invoice status — shared labels/colours/pipeline (mirrors backend utils/pmStatus.js).
// DB value → CareView label. Imported by PlanManagement, ParticipantProfile, ProviderProfile.

export const STATUS_LABEL = {
  extract_generated: 'AI draft',
  created: 'Awaiting approval',
  pending_participant: 'Pending participant',
  approved: 'Approved',
  claimed: 'Claim submitted',
  paid: 'Reconciled',
  provider_paid: 'Provider paid',
  declined: 'Declined',
  on_hold: 'On hold',
  claim_error: 'Claim error',
  cancelled: 'Cancelled',
};

// Badge colour per status.
export const INV_STATUS = {
  extract_generated: 'badge-gray',
  created: 'badge-gray',
  pending_participant: 'badge-yellow',
  approved: 'badge-blue',
  claimed: 'badge-purple',
  paid: 'badge-cyan',
  provider_paid: 'badge-green',
  declined: 'badge-red',
  on_hold: 'badge-yellow',
  claim_error: 'badge-red',
  cancelled: 'badge-red',
};

export const statusLabel = (s) =>
  STATUS_LABEL[s] || String(s || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

// The forward pipeline (left → right) for the board + the per-invoice stepper.
export const PIPELINE = ['extract_generated', 'created', 'pending_participant', 'approved', 'claimed', 'paid', 'provider_paid'];
